import { Injector, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import type { TranslateService } from '@ngx-translate/core';
import type { FormErrors } from '@tvd/design-system/form-error';

export const commonErrorMessages = (
  translator: TranslateService,
): FormErrors => {
  const injector = inject(Injector);
  return {
    required: toSignal(translator.get('validation.required')),
    email: toSignal(translator.get('validation.email')),
    invalidPhoneNumber: toSignal(
      translator.get('validation.invalidPhoneNumber'),
    ),
    name: toSignal(translator.get('validation.name')),
    invalidColor: toSignal(translator.get('validation.invalidColor')),
    invalidPostcode: toSignal(translator.get('validation.invalidPostcode')),

    minlength: ({ requiredLength }) =>
      toSignal(
        translator.get('validation.minlength', { value: requiredLength }),
        { injector },
      ),
    maxlength: ({ requiredLength }) =>
      toSignal(
        translator.get('validation.maxlength', { value: requiredLength }),
        { injector },
      ),
    // Signal-forms emit camelCase kinds carrying the limit on a like-named field.
    minLength: ({ minLength }) =>
      toSignal(translator.get('validation.minlength', { value: minLength }), {
        injector,
      }),
    maxLength: ({ maxLength }) =>
      toSignal(translator.get('validation.maxlength', { value: maxLength }), {
        injector,
      }),
    // Signal-forms PatternValidationError carries the RegExp on `pattern`.
    pattern: ({ pattern }: { pattern: RegExp }) =>
      toSignal(
        translator.get('validation.pattern', { value: pattern.source }),
        { injector },
      ),
    min: ({ min }) =>
      toSignal(translator.get('validation.min', { value: min }), { injector }),
    max: ({ max }) =>
      toSignal(translator.get('validation.max', { value: max }), { injector }),
  };
};
